<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.linkage") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-sync"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="getLinkageTypeGlobalList()"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="10%")
                          span(:title="$t('ui.name')" ) {{ $t('ui.name') }}
                        th(width="20%")
                          span(:title="$t('ui.description')" ) {{ $t('ui.description') }}
                        th.text-center(width="10%")
                          span(:title="$t('ui.risk_weight')" ) {{ $t('ui.risk_weight') }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.modified_date')" ) {{ $t('ui.modified_date') }}
                    tbody.clusterize-content
                      tr(v-if="list.length == 0")
                        td(colspan="5").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in list")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.type_name") {{ item.type_name }}
                        td
                          template(v-if="isEditAccess")
                            span(:title="item.type_desc")
                              a.text-primary.font-weight-bold.text-decoration-none(href="javascript:void(0)" @click="changeDesc(item)" :title="item.type_desc") {{ item.type_desc }}
                          template(v-else)
                            span(:title="item.type_desc") {{ item.type_desc }}
                        td.text-center
                          template(v-if="isEditAccess")
                            span(:title="item.risk_weight")
                              a.text-primary.font-weight-bold.text-decoration-none(href="javascript:void(0)" @click="changeRiskWeight(item)" :title="item.risk_weight") {{ item.risk_weight }}
                          template(v-else)
                            span(:title="item.risk_weight") {{ item.risk_weight }}
                        td.text-right
                          span(:title="item.modified_by") {{ item.modified_by ? item.modified_by : "-" }}
                          br
                          span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ item.modified_date ? $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') : "-" }}

      updatelinkagedesc(ref="updatelinkagedesc" :item="selectedLinkage"  @clicked="afterLinkageDesc" @failed="handleFailed")
      updatelinkageriskweight(ref="updatelinkageriskweight" :item="selectedLinkage"  @clicked="afterLinkageRiskWeight" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import updatelinkagedesc from "@/components/linkage/updateLinkageDesc.vue";
import updatelinkageriskweight from "@/components/linkage/updateLinkageRiskWeight.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    updatelinkagedesc,
    updatelinkageriskweight
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    list: [],
    selectedLinkage: null
  }),
  computed: {
    isEditAccess() {
      return this.$helpers.showActionButton("e_linkage");
    }
  },
  mounted: function() {
    this.getLinkageTypeGlobalList();
  },
  methods: {
    getLinkageTypeGlobalList: function() {
      let url = config.linkageTypeGlobalListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.list = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changeDesc: function(e) {
      this.selectedLinkage = e;
      this.$refs.updatelinkagedesc.$refs.updateLinkageDesc.show();
    },
    afterLinkageDesc: function() {
      this.getLinkageTypeGlobalList();
      this.$helpers.showDialog(this.$t("ui.combine.change_linkage_desc"), this.$t("message.success"), "success");
    },
    changeRiskWeight: function(e) {
      this.selectedLinkage = e;
      this.$refs.updatelinkageriskweight.$refs.updateLinkageRiskWeight.show();
    },
    afterLinkageRiskWeight: function() {
      this.getLinkageTypeGlobalList();
      this.$helpers.showDialog(this.$t("ui.combine.change_linkage_risk_weight"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>